import logo from './Hub71_Logo.png';

export default logo;
